import React from 'react'
import { formatName } from '@edge/spark/utils'
import { Container, TextField, SelectField } from '../Fields'
import { contactStatusOptions, contactMethodOptions } from './selectOptions'
import { useGetContactModalInfoQuery } from '../../../../spark_libs_deprecated/feature-contact-modal'

export const ContactFilterView: React.VFC = () => {
    const { data: contactData } = useGetContactModalInfoQuery()
    const { users } = contactData?.auction || {}
    const { types, statuses } = contactData?.auction?.contactManagement || {}

    const usersOptions = users?.length
        ? [['', 'N/A']].concat(
              users?.map((user) => {
                  const name = formatName(user)
                  return [name.toUpperCase(), name]
              }) || [],
          )
        : []

    const typesOptions = types?.length
        ? [['', 'N/A']].concat(
              types?.map((type) => (type?.code && type?.description ? [type?.code, type?.description] : [])) || [],
          )
        : contactMethodOptions

    const statusesOptions = statuses?.length
        ? [['', 'N/A']].concat(
              statuses?.map((status) =>
                  status?.code && status?.description ? [status?.code, status?.description] : [],
              ) || [],
          )
        : contactStatusOptions

    return (
        <Container>
            <TextField label="Has The Words" name="filters.hasWords" placeholder="Try any search term..." />
            <SelectField label="Status" name="filters.contact.contactStatus" options={statusesOptions} />
            <SelectField label="Method" name="filters.contact.contactMethod" options={typesOptions} />
            <SelectField label="Creator Name" name="filters.contact.creatorFullName" options={usersOptions} />
            <SelectField label="Followup Name" name="filters.contact.followupFullName" options={usersOptions} />
            <SelectField label="Completed Name" name="filters.contact.completedFullName" options={usersOptions} />
            <TextField label="Created Offset" name="filters.contact.contactedAt" placeholder="Try '10'" />
            <TextField label="Followup Offset" name="filters.contact.followupAt" placeholder="Try '10'" />
            <TextField label="Completed Offset" name="filters.contact.completedAt" placeholder="Try '10'" />
        </Container>
    )
}

export default ContactFilterView
